import type { Instruction, InstructionListResponse } from './types'

export const ALL_LIST_TAGS = [
  { type: 'Instruction' as const, id: 'LIST' },
  { type: 'Instruction' as const, id: 'MY_LIST' },
  { type: 'Instruction' as const, id: 'BOOKMARKS_LIST' },
  { type: 'Instruction' as const, id: 'COUNTS' },
]

/** Normalise backend response: may return a raw array or a paged object. */
export const arrayOrPaged = (
  raw: InstructionListResponse | Instruction[],
): InstructionListResponse => (Array.isArray(raw) ? { items: raw } : raw)
